import { api } from '../api';
import type { BannerContent } from './types';

// Proveedor de respaldo genérico (GOL-08A): cualquier emisor futuro no relacionado a
// billing (mantenimiento, disponibilidad de features) solo necesita escribir una fila
// `action_required` vía broadcastToTenants/broadcastToPlatform — aparece aquí sin
// tocar código nuevo. `GET /api/notifications` ya viene filtrado por scope según el
// rol de la sesión (tenant o platform), así que no hace falta pasarlo desde AppBanner.
export async function getNotificationBanner(navigate: (path: string) => void): Promise<BannerContent | null> {
  const { items } = await api.notifications.list().catch(() => ({ items: [], unreadCount: 0 }));
  const top = items.find((n) => n.severity === 'action_required' && !n.readAt);
  if (!top) return null;

  return {
    tone: 'danger',
    message: top.body ? `${top.title} · ${top.body}` : top.title,
    actionLabel: top.actionLabel || 'Ver más',
    onAction: async () => {
      await api.notifications.markRead(top.id).catch(() => { /* ignore */ });
      navigate(top.actionUrl || '/notifications');
    },
  };
}
